import { useEffect, useRef, useState } from 'react';
import { Alert, Anchor, Container, Loader, Text } from '@mantine/core';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HttpClient from '../helpers/HttpClient';
import { setMagicLinkSession } from '../helpers/TokenRefresh';
import { useUserContext } from '../providers/UserContext';

function MagicLinkVerify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUserRights } = useUserContext();
  const [error, setError] = useState<string | null>(null);
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setError('Kein Login-Link angegeben.');
      return;
    }

    const verify = async () => {
      try {
        const result = await new HttpClient('/auth/magic-link').postAction('verify', { token }) as unknown as { accessToken?: string };
        if (!result?.accessToken) throw new Error('no access token');
        setMagicLinkSession(result.accessToken);
        await refreshUserRights();
        navigate('/', { replace: true });
      } catch {
        setError('Der Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Login-Link an.');
      }
    };
    verify();
  }, [searchParams, navigate, refreshUserRights]);

  return (
    <Container size="xs" mt="xl">
      {error ? (
        <Alert color="red" title="Anmeldung fehlgeschlagen">
          <Text mb="sm">{error}</Text>
          <Anchor onClick={() => navigate('/')}>Zurück zur Startseite</Anchor>
        </Alert>
      ) : (
        <>
          <Loader size="md" />
          <Text mt="sm">Anmeldung wird überprüft…</Text>
        </>
      )}
    </Container>
  );
}

export default MagicLinkVerify;
